<template>
  <div class="ba-sidebar">
    <ul class="ba-nav">
      <li class="ba-nav-item">
        <component
          :is="'router-link'"
          v-bind="{ to: { name: 'Dashboard' }}"
          :class="{'ba-is-active': $route.name === 'Dashboard'}"
          class="ba-link"
        >
          <builderall-icon code="sitebuilder"/>
          <span class="ba-title">{{ $t('ct-dashboard') }}</span>
        </component>
      </li>
      <li class="ba-nav-item">
        <component
          :is="'router-link'"
          v-bind="{ to: { name: 'CreateWebsite', query: { step: 'template' }}}"
          :class="{'ba-is-active': $route.name == 'CreateWebsite'}"
          class="ba-link"
        >
          <builderall-icon code="2780"/>
          <span class="ba-title">{{ $t('ct-new-website') }}</span>
        </component>
      </li>
      <li v-if="Object.keys(website).length && (isExpandedWebsite())" class="ba-nav-item">
        <input
          id="ba-toggle-expandable-content-2"
          :disabled="isExpandedWebsite()"
          type="checkbox"
          checked
          class="ba-nav-item-input-status"
        >
        <label class="ba-nav-item-expandable" for="ba-toggle-expandable-content-2">
          <div class="ba-nav-item-expandable-content">
            <builderall-icon code="7faf"/>
            <span class="ba-title">{{ $t('ct-my-websites') }}</span>
            <builderall-icon code="5da4" class="ba-link-expandable-icon" />
          </div>
          <ul class="ba-nav-subitems">
            <hr class="ba-hr-row">
            <li class="ba-nav-subitem">
              <component
                :is="'router-link'"
                v-bind="{ to: { name: 'Home' } }"
                class="ba-nav-subitem-link ba-back"
              >
                <builderall-icon code="arrow-left"/>
                <span class="ba-title">{{ $t('ct-all-websites') }}</span>
              </component>
            </li>
            <li class="ba-nav-subitem">
              <a class="ba-nav-subitem-link ba-current-section">
                <span class="ba-title">{{ website.title }}</span>
              </a>
            </li>
            <li class="ba-nav-subitem">
              <component
                :is="isExitPopupInBundleAccess ? 'span' : 'router-link'"
                v-bind="!isExitPopupInBundleAccess ? { to: { name: 'SitePages', params: { id: website.encrypted_id, data: website } } }: {}"
                :class="{'ba-is-active': active === 'site-pages', 'ba-disabled': isExitPopupInBundleAccess}"
                class="ba-nav-subitem-link"
              >
                <builderall-icon code="pages" />
                <span class="ba-title">{{ $t('ct-my-pages') }}</span>
              </component>
            </li>
            <li class="ba-nav-subitem">
              <component
                :is="isExitPopupInBundleAccess ? 'span' : 'router-link'"
                v-bind="!isExitPopupInBundleAccess ? { to: { name: 'GeneralSettings', params: { id: website.encrypted_id, data: website }}} : {}"
                :class="{'ba-is-active': active === 'general-settings', 'ba-disabled': isExitPopupInBundleAccess}"
                class="ba-nav-subitem-link"
              >
                <builderall-icon code="general-settings"/>
                <span class="ba-title">{{ $t('ct-website-settings') }}</span>
              </component>
            </li>
            <li class="ba-nav-subitem">
              <router-link
                :class="{ 'ba-is-active': active == 'items' }"
                :to="{ name: 'Items', params: { id: website.encrypted_id, layout_id: website.layouts[0].encrypted_id}, query: { is_exit_popup_in_bundle_access: isExitPopupInBundleAccess }}"
                class="ba-nav-subitem-link"
              >
                <builderall-icon code="elements"/>
                <span class="ba-title">{{ $t('ct-items-all-edit') }}</span>
              </router-link>
            </li>
            <li v-if="showMembersArea" class="ba-nav-subitem">
              <component
                :is="isExitPopupInBundleAccess ? 'span' : 'router-link'"
                v-bind="!isExitPopupInBundleAccess ? { to: { name: 'SiteMembers', params : { website_id : website.encrypted_id , data: website }}} : {}"
                :class="{ 'ba-is-active': active === 'site-members', 'ba-disabled': isExitPopupInBundleAccess }"
                class="ba-nav-subitem-link"
              >
                <builderall-icon code="profile"/>
                <span class="ba-title">{{ $t('ct-members-area') }}</span>
              </component>
            </li>
            <li v-if="showMembersArea" class="ba-nav-subitem">
              <component
                :is="isExitPopupInBundleAccess ? 'span' : 'router-link'"
                :class="{ 'ba-is-active': active == 'form-members', 'ba-disabled': isExitPopupInBundleAccess }"
                :to="!isExitPopupInBundleAccess ? { name: 'FormMembers', params : { website_id : website.encrypted_id , data: website }} : {}"
                class="ba-nav-subitem-link"
              >
                <builderall-icon code="member"/>
                <span class="ba-title">{{ $t('ct-members-form') }}</span>
              </component>
            </li>
            <li class="ba-nav-subitem">
              <component
                :is="isExitPopupInBundleAccess ? 'span' : 'router-link'"
                v-bind="!isExitPopupInBundleAccess ? { to: { name: 'Integrations', params: { id: website.encrypted_id, data: website }}} : {}"
                :class="{'ba-is-active': active === 'integrations', 'ba-disabled': isExitPopupInBundleAccess}"
                class="ba-nav-subitem-link"
              >
                <builderall-icon code="integrations"/>
                <span class="ba-title">{{ $t('ct-integrations') }}</span>
              </component>
            </li>
            <li class="ba-nav-subitem">
              <a
                :class="{ 'ba-disabled': tokenCheckout === false || $isBundle() }"
                class="ba-nav-subitem-link"
                @click.prevent="openSupercheckout()"
              >
                <builderall-icon code="checkout"/>
                <span class="ba-title">{{ $t('ct-supercheckout') }}</span>
              </a>
            </li>
            <li class="ba-nav-subitem">
              <a
                :class="{'ba-disabled': isExitPopupInBundleAccess}"
                class="ba-nav-subitem-link"
                @click.prevent="!isExitPopupInBundleAccess ? openBlog() : {}"
              >
                <builderall-icon code="blog"/>
                <span class="ba-title">{{ $t('ct-blog') }}</span>
              </a>
            </li>
            <li class="ba-nav-subitem">
              <a
                :class="{'ba-disabled': isExitPopupInBundleAccess}"
                class="ba-nav-subitem-link"
                @click.prevent="!isExitPopupInBundleAccess ? openBooking() : {}"
              >
                <builderall-icon code="booking"/>
                <span class="ba-title">{{ $t('ct-booking') }}</span>
              </a>
            </li>
            <li class="ba-nav-subitem">
              <component
                :is="isExitPopupInBundleAccess ? 'span' : 'router-link'"
                v-bind="!isExitPopupInBundleAccess ? { to: { name: 'Domain', params: {id: website ? website.encrypted_id : websiteObj.encrypted_id }}} : {}"
                :class="{'ba-is-active': active === 'domain', 'ba-disabled': isExitPopupInBundleAccess}"
                class="ba-nav-subitem-link"
              >
                <builderall-icon code="dns"/>
                <span class="ba-title">{{ $t("ct-domain") }}</span>
              </component>
            </li>
            <li class="ba-nav-subitem">
              <component
                :is="isExitPopupInBundleAccess ? 'span' : 'router-link'"
                v-bind="!isExitPopupInBundleAccess ? { to: { name: 'Analytics', params: { id: website.encrypted_id, data: website }}} : {}"
                :class="{'ba-is-active': active === 'analytics', 'ba-disabled': isExitPopupInBundleAccess}"
                class="ba-nav-subitem-link"
              >
                <builderall-icon code="601d"/>
                <span class="ba-title">{{ $t('ct-gdpr-analytics-type') }}</span>
              </component>
            </li>
            <li class="ba-nav-subitem">
              <component
                :is="isExitPopupInBundleAccess ? 'span' : 'router-link'"
                v-bind="!isExitPopupInBundleAccess ? { to: { name: 'Others', params: { id: website.encrypted_id, data: website }}} : {}"
                :class="{'ba-is-active': active === 'others', 'ba-disabled': isExitPopupInBundleAccess}"
                class="ba-nav-subitem-link"
              >
                <builderall-icon code="others"/>
                <span class="ba-title">{{ $t('ct-others') }}</span>
              </component>
            </li>
          </ul>
        </label>
      </li>
      <li v-else class="ba-nav-item">
        <component
          :is="'router-link'"
          v-bind="{ to: { name: 'Home' }}"
          :class="{'ba-is-active': $route.name == 'Home'}"
          class="ba-link"
        >
          <builderall-icon code="7faf"/>
          <span class="ba-title">{{ $t('ct-my-websites') }}</span>
        </component>
      </li>
      <li class="ba-nav-item">
        <component
          :is="'router-link'"
          v-bind="{ to: { name: 'Tags' }}"
          :class="{'ba-is-active': $route.name == 'Tags'}"
          class="ba-link"
        >
          <builderall-icon code="7347"/>
          <span class="ba-title">{{ $t('ct-create-tag-group') }}</span>
        </component>
      </li>
      <li class="ba-nav-item">
        <component
          :is="'router-link'"
          v-bind="{ to: { name: 'UserSettings' }}"
          :class="{'ba-is-active': $route.name == 'UserSettings'}"
          class="ba-link"
        >
          <builderall-icon code="general-settings"/>
          <span class="ba-title">{{ $t('ct-general-settings') }}</span>
        </component>
      </li>
      <li class="ba-nav-item" v-if="$i18n.locale === 'es_ES' && !$isBundle()">
        <router-link
          :to="{ name: 'AiResources' }"
          target="_blank"
          rel="noopener noreferrer"
          class="ba-link"
        >
          <builderall-icon code="2425"/>
          <span class="ba-title">Recursos IA</span>
        </router-link>
      </li>
    </ul>
    <div class="ba-bottom">
      <ul class="ba-bottom-list">
        <li>
          <builderall-help/>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { apiUrl, auth as supercheckoutAuth } from '../../js/services/integrations-internas/supercheckout';
import {mapGetters} from 'vuex';
import axios from 'axios';

export default {
  name: 'SiteSidebar',

  data() {
    return {
      active: '',
      betaTester: false,
      tokenCheckout: false,
      errorToken: null,
      websiteObj: {},
    };
  },

  watch: {
    $route: function(route) {
      if (route.name) this.setActiveRouteName(route.name, route.params);
    },
    'website.encrypted_id': function(website) {
      this.getSuperCheckoutAuth();
    }
  },

  created() {
    this.getSuperCheckoutAuth();
    if (this.$route.name) this.setActiveRouteName(this.$route.name, this.$route.params);
  },

  mounted() {
    let vm = this;
    setTimeout(() => {
      vm.getSuperCheckoutAuth();
    }, 2000);
    vm.$forceUpdate();
  },

  methods: {
    goToUpgrade(){
      window.open('https://checkout.builderall.com/plans', '_blank');
    },
    isExpandedWebsite(){
      let status = ['site-pages', 'site-settings', 'domain', 'items', 'general-settings', 'analytics', 'integrations', 'others', 'site-page-create', 'cheetah-turbo-page', 'site-page-edit', 'site-page-versions', 'site', 'site-members', 'form-members'];
      return status.find(x => x == this.active || this.active.startsWith(x));
    },
    openSupercheckout() {
      if (this.$isBundle()) {
        this.goToUpgrade();
        return;
      }

      supercheckoutAuth(this.website.id, this.website.language).then(async({data}) => {
          if (data.token) {
            let token = data.token;
            localStorage.setItem('token_supercheckout', token);
            this.tokenCheckout = token;

            return window.open(`${apiUrl()}?token=${this.tokenCheckout}`);
          } else
            this.errorToken = error;

        });
    },
    getBlogUrl() {
      const baseURLs = {
          'local':'http://blog.localhost',
          'io'   :'https://blog.kub.app.builderall.io',
          'info' :'https://blog.kub.app.builderall.info',
          'com'  :'https://blog.builderall.com'
      };

      let url = '';

      if(window.location.host.includes('localhost:'))
        url = baseURLs.local;
       else {
        url = baseURLs[
          window.location.host.includes('.com') ? 'com' : (
            window.location.host.includes('.info') ? 'info' : 'io'
          )
        ];
      }

      return `${url}/logincheetah-login?token=J0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9&user_token=${this.getOfficeToken}`;
    },
    openBlog() {
      let url = this.getBlogUrl();
      url = url + '&website_id=' + this.website.encrypted_id;
      window.open(url, '_blank');
    },

    checkBlogAceess() {
      if (this.website && typeof this.website.encrypted_id !== 'undefined') {
        let vm = this;
        vm.betaTester = true;
        let url = this.getBlogUrl();
        url = url + '&website_id=' + this.website.encrypted_id;
        axios.get(url + '&checkIsBeta=true')
          .then(({data}) => {
            if (data.beta_tester)
              vm.betaTester = true;

          });
      }
    },

    getSuperCheckoutAuth() {
      if (this.website && typeof this.website.encrypted_id !== 'undefined') {
        var error = this.$t('ct-checkout-erro-retrieving-token');
        supercheckoutAuth(this.website.id, this.website.language).then(async({data}) => {
          if (data.token) {
            let token = data.token;
            localStorage.setItem('token_supercheckout', token);
            this.tokenCheckout = token;
          } else
            this.errorToken = error;

        });
      }
    },

    setActiveRouteName(routeName, params) {
      if (typeof params.type_item !== 'undefined' && params.type_item.length)
        routeName = `${routeName}-${params.type_item}`;


      this.active = routeName.replace(/(?:^|\.?)([A-Z])/g, function(x, y) {
        return '-' + y.toLowerCase();
      }).replace(/^-/, '');
    },
    openBooking() {
      let token = localStorage.getItem('token') || false;
      let user = this.getUser;

      if (token && user && parseInt(user.id_office_user)) {
        let urlWeb = (process.env.NODE_ENV === 'development' || location.hostname === 'editor-dev.builderall.io') ?
            'https://office.builderall.io/us/office/booking' :
            'https://office.builderall.com/us/office/booking';

        const form = document.createElement('form');

        form.method = 'GET';
        form.action = urlWeb;
        form.target = '_blank';
        form.id = 'form-booking';

        document.body.appendChild(form);
        form.submit();
        document.body.removeChild(form);
      }
    },
  },
  computed: {
    ...mapGetters({getUser: 'user', getUserToken: 'token', getOfficeToken: 'getOfficeToken', website: 'website'}),
    showMembersArea() {
      if (typeof this.website !== 'undefined' && typeof this.website.restrict_areas !== 'undefined') return this.website.restrict_areas.length > 0;
      return false;
    },
    isExitPopupInBundleAccess() {
      return this.$isBundle() && this.website && this.website.is_exit_popup;
    }
  }
};
</script>

<style scoped lang="scss">
    .ba-link,
    .ba-nav-item,
    .ba-title,
    a{
        text-decoration: none;
    }
    .ba-disabled{
      opacity: 0.3;
      cursor: not-allowed;
    }
</style>



// WEBPACK FOOTER //
// src/components/general/Sidebar.vue